<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content" @before-close="closeDialog" :click-to-close="!tourStatus">


    <div class="modal-header justify-content-between">
      <span class="modal__title text-white">Set Frequency</span>

      <div>
        <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
      </div>
    </div>

    <div class="modal__body">
      <div class="modal__content mt-3 mb-4" id="set-frequency">
        <div class="draggable-line mt-4">
          <div class="col-12 label-container" style="display: inline-block; text-align: center; width: 100%;">
            <div class="label">Campaign Sent Every:</div>
            <div class="number-label">{{dayLabel}}</div>
          </div>
          <div class="draggable mt-5" ref="draggable" @mousedown="startDragging" @mouseup="stopDragging">
            <div class="line" :style="{ width: lineWidth + 'px', left: lineLeft + 'px' }"></div>
            <div class="dot" :style="{ left: dotLeft + 'px' }" ref="dot"></div>
          </div>
        </div>

        <div class="pt-2 mt-4">
          <input v-model="selectedDays" type="number" class="form-control custom-width-input mt-4" :class="selectedDays < 15 ?'mb-1' : 'mb-4'" placeholder="Days">
          <div class="text-danger small text-center mb-3 mt-0 fw-lighter" v-if="selectedDays < 15">Minimum 15 days required.</div>
          <div class="text-danger small text-center mb-3 mt-0 fw-lighter" v-if="selectedDays > 365">Maximum 365 days required.</div>
          <div class="col-12">
            <div class="text-center p-1">
              <button type="button" class="btn btn-outline-primary-inverse" @click="confirm" :disabled="selectedDays < 15 || selectedDays > 365">Confirm</button>
            </div>
          </div>
        </div>

      </div>
    </div>

  </vue-final-modal>
 </template>

 <script>
 export default {
  name: "Frequency",

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    onboarding: {
      type: Object,
      required: false
    },
    tourStatus: {
      type: Boolean,
      required: false,
    },
  },

   data() {
     return {
       state: true,
       isDragging: false,
       lineWidth: 0,
       lineLeft: 0,
       dotLeft: 0,
       minDays: 15,
       maxDays: 365,
       selectedDays: 180
     };
   },

   mounted() {
    window.addEventListener('mousemove', this.handleDragging);
    window.addEventListener('mouseup', this.stopDragging);
    this.lineWidth = '520px';
    this.lineLeft = (this.$refs.draggable.offsetWidth - parseInt(this.lineWidth)) / 2;
    const range = this.maxDays - this.minDays;

    this.$nextTick(() => {
      const percent = (this.selectedDays - this.minDays) / range;
      this.dotLeft = (this.$refs.draggable.offsetWidth - 20) * percent;
    });
  },

   methods: {
    startDragging(event) {
      event.preventDefault();
      this.isDragging = true;
    },

    stopDragging(event) {
      event.preventDefault();
      this.isDragging = false;
    },

    handleDragging(event) {
      event.preventDefault();
      if (!this.isDragging) {
        return;
      }
      const rect = this.$refs.draggable.getBoundingClientRect();
      const x = event.clientX - rect.left;
      let newX = x;
      if (newX < 0) {
        newX = 0;
      } else if (newX > rect.width) {
        newX = rect.width;
      }
      const range = this.maxDays - this.minDays;
      const newDays = Math.max(this.minDays, Math.round(this.minDays + range * (newX / rect.width)));
      const dotWidth = this.$refs.dot.offsetWidth;
      const halfDotWidth = dotWidth / 2; // Half of the dot's width
      this.dotLeft = newX - halfDotWidth; // Adjusted dot position
      this.selectedDays = newDays;
    },

    confirm(){
      this.$emit('confirm', this.selectedDays);
      if (this.tourStatus)
        this.onboarding.goToStep(2)

      this.state = false;
    },

     closeDialog() {
      this.$emit("close");
      this.state = false;
      },
   },

   computed: {
    dayLabel() {
      return this.selectedDays === 1 ? `${this.selectedDays} Day` : `${this.selectedDays} Days`;
    },
  },

 };
 </script>

 <style scoped>
 .draggable {
   display: flex;
   align-items: center;
   justify-content: center;
   position: relative;
   height: 4px;
   width: 90%;
   background: #D9D9D9;
   margin-top: 25px;
   text-align: center;
   margin: auto;
 }

 .draggable::before,
 .draggable::after {
   content: "";
   position: absolute;
   width: 4px;
   height: 14px;
   background: #435666;
   z-index: 1; /* set a higher z-index to appear above the dot */
 }

 .draggable::before {
   left: -4px;
 }

 .draggable::after {
   right: -4px;
 }

 .dot {
   position: absolute;
   height: 20px;
   width: 20px;
   border-radius: 50%;
   background-color: #00A0C1;
   left: 0;
   top: 7px; /* adjust this value to change the distance between the dot and the line */
   z-index: 0; /* set a lower z-index to appear behind the line */
   cursor: pointer;
 }

 .dot::before,
 .dot::after {
   content: "";
   position: absolute;
   height: 14px;
   width: 4px;
   background: #00A0C1;
   top: -13px;
   left: 8px;
   transform: rotate(180deg);
 }

 .dot::after {
   left: 8px;
   transform: rotate(180deg);
 }



  .line {
   height: 2px;
   width: 520px;
   background-color: #D9D9D9;
   position: relative;
   margin-top: 14px;
 }
   .label {
    margin-top: 10px;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #435666;
   }

   .number-label {
    text-align: center;
    font-weight: 900;
    font-size: 32px;
    line-height: 100%;
    text-align: center;
    color: #435666;
   }

   .custom-width-input {
    width: 159px; /* Adjust the width as needed */
    margin: auto;
    text-align: center;
    font-size:14px;
  }
 </style>

<style scoped>
/* Hide number input spinners */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
